// Ajitesh : 16/02/2024: BT-109380 Contact Us - Reducer for "Help" menu - Start
import { HELP } from "../actionTypes"

const initialState = {
    branchDetails: [],
    isLoadingBranchesInfo: false
}

const helpReducer = (state = initialState, action) => {
    switch(action.type) {
        case HELP.GET_BRANCH_DETAILS_SUCCESS:
            return {
                ...state,
                branchDetails: action.payload
            }
        case HELP.GET_BRANCH_DETAILS_FAILURE:
            return {
                ...state,
                branchDetails: action.payload
            }
        case HELP.UPDATE_IS_LOADING_BRANCHES_INFO:
            return {
                ...state,
                isLoadingBranchesInfo: action.payload
            }
        default:
            return state;
    }
}

export default helpReducer;
// Ajitesh : 16/02/2024: BT-109380 Contact Us - Reducer for "Help" menu - End